import styled from 'styled-components';
import { detectMobile } from 'utils/UiHelper';
import { breakpoint } from '../../constants/breakpoints';

export const RequestBetContainer = styled.div`
    width: ${detectMobile() ? '95%' : '100%'};
    margin: ${detectMobile() ? '10px' : '10px 0'};
    padding: 15px 24px;
    display: flex;
    //justify-content: space-between;
    align-items: stretch;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    transition: all 0.3s linear;
    ${({ isClosed }) =>
        isClosed ? 'height: 50px;' : null} flex-direction: 'row';
    background: #e4effe;
    border: 1px solid #d3e3fb;
    border-radius: 5px;
    .view-spinner {
        padding: 0;
        .fa-2x {
            font-size: 1em;
        }
    }
    @media screen and ${breakpoint.MinB} {
        padding: 16px 15px 23px;
    }
`;
export const RequestBetIconWrapper = styled.div`
    height: auto;
    width: 30px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 16px 0 0;
    img {
        height: 20px;
        width: 20px;
        display: block;
        box-sizing: border-box;
    }
`;

export const RequestBetContentWrapper = styled.div`
    height: auto;
    width: calc(100% - 30px);
    display: flex;
    flex-direction: column;
    @media screen and ${breakpoint.MinB} {
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;
export const InnerContainer = styled.div`
    display: flex;
    align-items: ${({ column }) => (column ? 'flex-start' : 'center')};
    flex-direction: ${({ column }) => (column ? 'column' : 'row')};
    justify-content: space-between;
    &.right {
        margin: 10px 0 0;
    }
    @media screen and ${breakpoint.MinB} {
        width: 50%;
        &.right {
            margin: 0;
            padding-left: 54px;
            justify-content: space-between;
            align-items: flex-start;
            input {
                width: calc(100% - 87px) !important;
                max-width: 100%;
            }
            button {
                width: 80px !important;
            }
        }
    }
`;

export const RequestBetInput = styled.input`
    padding: 10px 5px 10px 15px;
    border-radius: 5px;
    border: none;
    outline: none;
    width: calc(100% - 70px);
    display: inline-block;
    max-width: 85%;
    color: #333;
    font-size: 14px;
    
    transition: all 0.4s ease-in-out; 
    ::placeholder {
        color: #d4d6e4;
    }
    &:focus {
        box-shadow: 0 0 30px #fff;
    }
   /* @media screen and (max-width: 1400px) {
        width: 200px;
    }
    @media screen and (max-width: 1270px) {
        width: 150px;
    }
    @media screen and (max-width: 1180px) {
        width: 100px;
    }
    @media screen and (max-width: 1150px) {
        width: ${detectMobile() ? '85%' : '100px'};
    }*/
`;

export const SlideButton = styled.div`
    height: 23px;
    width: 23px;
    border-radius: 5px;
    background: #585858;
    position: absolute;
    top: 15px;
    right: 15px;
    text-align: center;
    .fa-caret-up {
        color: white;
        transition: all 0.2s linear;
        ${({ isClosed }) =>
            isClosed ? 'transform: translateY(4px) rotate(180deg)' : ''};
    }
`;
